import { align } from '@/styles/display'
import { fontSize } from '@/styles/font'
import spaceStyle from '@/styles/space'
import { SubButton } from '../base/Button'
import { buttonSize } from '../base/Button/Base'
// import { InputText } from '../base/Form/InputText'
import SelectorPopContainer from '@/feature/Builder/Component/containers/SelectorPopupContainer'
import { useApp } from '@/hooks/useApp'
import { commonBorder } from '@/styles/border'
import borderRadius from '@/styles/border_radius'
import _, { isBoolean } from 'lodash'
import {
  type V1FormElement,
  type V1FormElementContentState,
  type V1FormElementState,
  V1FormElementStateType,
  type V1FormElementUiTextAndSelectorPopup,
  V1FormElementUiType
} from 'mnvm-mypage-app-ts-if'
import { type ReactNode, useState } from 'react'
import styled from 'styled-components'
import { Block } from '../base/Block'
import InputErrorLabel from '../base/Form/InputErrorLabel'
import { Row } from '../base/Layout'
import { Text3 } from '../base/Text'
import useIsMobile from '@/hooks/useMobile'

export const FormELementTextAndSelectorPopup = ({
  form,
  onChange,
  isEdit,
  formElementState,
  elemenErrorMessage,
  isHorizontalLayoutProfile
}: {
  isEdit: boolean
  form: V1FormElement
  formElementState: V1FormElementState
  onChange: (newState: V1FormElementState) => void
  elemenErrorMessage?: string
  isHorizontalLayoutProfile?: boolean
}): JSX.Element => {
  const { ui } = form
  const { popup, readOnly } = ui as V1FormElementUiTextAndSelectorPopup
  const [isOpen, setIsOpen] = useState(false)
  const app = useApp()
  const isReadOnly = isBoolean(readOnly) && readOnly
  const isMobile = useIsMobile()

  const defaultSelected = (formElementState?.contentStates ?? []).map((e) => {
    switch (formElementState?.type) {
      case V1FormElementStateType.Uint32:
      case V1FormElementStateType.Uint32List:
        return e.uint32?.toString() ?? ''
      case V1FormElementStateType.Text:
      case V1FormElementStateType.TextList:
        return e.text ?? ''
      case V1FormElementStateType.Bool:
      case V1FormElementStateType.BoolList:
        return e.bool?.toString() ?? ''
      default:
        return ''
    }
  })
  const selectedLabel = (formElementState?.contentStates ?? [])
    .map((e) => {
      return e.label?.toString() ?? ''
    })
    .join('/')

  const widthSelectedProfileField = (): string | undefined => {
    if (isHorizontalLayoutProfile ?? false) {
      if (isMobile) {
        return '100%'
      } else return '300px'
    }
  }

  if (!isEdit) {
    return (
      <Block width={widthSelectedProfileField()}>
        <Text3 textAlign={align.LEFT} margin={{ all: spaceStyle.NONE }}>
          {selectedLabel}
        </Text3>
      </Block>
    )
  }

  return (
    <>
      <Row
        gutter={
          selectedLabel !== '' || isHorizontalLayoutProfile === true ? 8 : 0
        }
        align={align.CENTER}
        flexWrap="nowrap"
      >
        <Block
          display="flex"
          height="36px"
          style={{
            width:
              isHorizontalLayoutProfile ?? false
                ? isMobile
                  ? '100%'
                  : '120px'
                : 'fit-content'
          }}
          border={
            !isReadOnly
              ? {
                  ...commonBorder,
                  color:
                    elemenErrorMessage !== undefined
                      ? app.theme.errorMainColor
                      : app.theme.frameColor
                }
              : false
          }
          borderRadius={{ all: borderRadius.M }}
          padding={{
            horizontal:
              selectedLabel !== '' || isHorizontalLayoutProfile === true
                ? spaceStyle.M
                : spaceStyle.NONE
          }}
          alignItems="center"
        >
          <Text3
            truncate
            textAlign={align.LEFT}
            margin={{ all: spaceStyle.NONE }}
          >
            {selectedLabel}
          </Text3>
        </Block>
        {/* <InputText
          maxWidth={267}
          name={'name'}
          value={defaultSelected.join(' ')}
          onChange={(value) => {}}
        /> */}
        <SubButton
          maxWidth="72px"
          height={buttonSize.S}
          onClick={() => {
            setIsOpen(true)
          }}
          fontSize={fontSize.S}
          padding={{
            vertical: spaceStyle.M,
            horizontal: spaceStyle.XL
          }}
        >
          {isReadOnly || (isHorizontalLayoutProfile ?? false) ? '選択' : '検索'}
        </SubButton>
      </Row>
      {popup?.viewId !== undefined ? (
        <SelectorPopContainer
          isOpen={isOpen}
          viewId={popup?.viewId ?? ''}
          onSelect={(items, text) => {
            setIsOpen(false)
            const createNewState = (
              item: string
            ): V1FormElementContentState => {
              switch (formElementState?.type) {
                case V1FormElementStateType.Uint32:
                case V1FormElementStateType.Uint32List:
                  return { uint32: _.parseInt(item), label: text }
                case V1FormElementStateType.Text:
                case V1FormElementStateType.TextList:
                  return { text: item, label: text }
                case V1FormElementStateType.Bool:
                case V1FormElementStateType.BoolList:
                  return {
                    bool:
                      item.toLowerCase() === 'true' ||
                      item.toLowerCase() === '1',
                    label: text
                  }
                default:
                  return {}
              }
            }

            const contentStates: V1FormElementContentState[] =
              items.map(createNewState)
            const state: V1FormElementState = {
              ...formElementState,
              contentStates: contentStates.length === 0 ? [] : contentStates
            }
            onChange(state)
          }}
          defaultSelected={defaultSelected}
          onClose={() => {
            setIsOpen(false)
          }}
        />
      ) : undefined}
      {elemenErrorMessage !== undefined && (
        <InputErrorLabel message={elemenErrorMessage} />
      )}
    </>
  )
}

const FormELementTextAndSelectorPopupGroupContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 12px;
  row-gap: 12px;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 670px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const FormELementTextAndSelectorPopupGroup = ({
  children
}: {
  children: ReactNode
}): JSX.Element => {
  return (
    <FormELementTextAndSelectorPopupGroupContainer>
      {children}
    </FormELementTextAndSelectorPopupGroupContainer>
  )
}

export const isFormELementTextAndSelectorPopupGroup = (
  elements: V1FormElement[]
): boolean => {
  return (
    elements.length > 1 &&
    _.every(elements, (element) => {
      return element.uiType === V1FormElementUiType.TextAndSelectorPopup
    })
  )
}
